import {
  Text,
  Box,
  HStack,
  VStack,
  IconButton,
  Badge,
  Flex,
  Link,
} from '@chakra-ui/react';

import { CloseIcon, DownloadIcon } from '@chakra-ui/icons';

interface FileUploadCardProps {
  file: {
    id: number;
    name: string;
    file_type: number;
    file_url: string;
    created_at: string;
    user: string;
  };
  badgeText: string;
  badgeColorScheme?: string;
  onDelete: (fileId: number) => void;
  isDeleting?: boolean;
  isLocked?: boolean;
}

const FileUploadCard = ({
  file,
  badgeText,
  badgeColorScheme = 'blue',
  onDelete,
  isDeleting = false,
  isLocked = false,
}: FileUploadCardProps) => {
  return (
    <Box
      p={4}
      borderWidth="1px"
      borderRadius="lg"
      borderColor="blue.200"
      bg="blue.50"
      w="full"
      shadow="sm"
    >
      <Flex direction="column" gap={3}>
        <HStack justify="space-between" align="start">
          <HStack spacing={3} flex={1} minW={0}>
            <VStack align="start" spacing={1} flex={1} minW={0}>
              <Text
                fontSize="sm"
                fontWeight="600"
                color="gray.800"
                noOfLines={1}
              >
                {file.name}
              </Text>
              <HStack spacing={2}>
                <Badge colorScheme={badgeColorScheme} size="sm">
                  {badgeText}
                </Badge>
                <Text fontSize="xs" color="gray.600">
                  Uploaded by {file.user}
                </Text>
              </HStack>
              <Text fontSize="xs" color="gray.500">
                {new Date(file.created_at).toLocaleDateString()} at{' '}
                {new Date(file.created_at).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </Text>
            </VStack>
          </HStack>

          <HStack spacing={1}>
            {file.file_url && (
              <IconButton
                aria-label="Download file"
                icon={<DownloadIcon />}
                size="sm"
                variant="ghost"
                colorScheme="blue"
                as={Link}
                href={file.file_url}
                target="_blank"
                rel="noopener noreferrer"
                _hover={{ bg: 'blue.100' }}
              />
            )}
            {!isLocked && (
              <IconButton
                aria-label="Remove file"
                icon={<CloseIcon />}
                size="sm"
                variant="ghost"
                colorScheme="red"
                onClick={() => onDelete(file.id)}
                isLoading={isDeleting}
                _hover={{ bg: 'red.100' }}
              />
            )}
          </HStack>
        </HStack>
      </Flex>
    </Box>
  );
};

export default FileUploadCard;
